module.exports = __webpack_public_path__ + "img/16.bd0b8843.svg";